

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */
/* eslint no-useless-escape: "warn" */
/*
beware! this file is common to legacy wizard and to new fpa-int viewer, so don't add fpa-int specific stuff here
*/

import 'jquery-validation';

import $ from 'jquery';

import { getTranslator } from './i18n';
import { moment, numeral, PNotify } from './init';
import { getUiText } from './js_data';

const t = getTranslator();

const errutil = {
    parse(data, ex) {
        let stack = '';
        let lex = new Error();
        if(typeof (ex) == 'string') {
            lex = new Error(ex);
            ex = null;
        }
        if(ex) {
            stack = lex.stack || '';
        } else {
            ex = lex;
        }
        if(stack)
            stack += '\n...\n';
        stack += ex.stack || '';

        let message = ex.message || '';
        let clazz = '';
        if(typeof (data) == 'string')
            message = message + (message ? ', ' : '') + data;
        //server json error
        else if(data && data.error && (data.reason || data.stack)) {
            if(data.reason)
                message = data.reason;
            if(data.stack) {
                if(stack)
                    stack += '\n...\n';
                stack += data.stack;
            }
            if(data.error)
                clazz = data.error;
        }

        if(!clazz)
            clazz = Object.prototype.toString.call(ex).slice(8, -1);
        if(!stack)
            stack = 'Unknown stack';

        ex.message = message;
        ex.parsedex = { stack, clazz };
        return ex;
    },
    errorMessageHandler(text, type, title, delay) {
        if(!type)
            type = 'error';
        if((type == 'error') && !title)
            title = t('common.attention');
        PNotify.alert({
            title: title || '', text, type, delay: (delay && Number(delay)) || 20000,
        });
    },
    box(data, ex, options) {
        if(!options)
            options = {};
        if(!ex || !ex.parsedex || (typeof (ex) == 'string'))
            ex = errutil.parse(data, ex);

        const parsed = ex.parsedex;
        const container = $('#error-message-container');
        if(container.length) {
            container.text(ex.message).slideDown();
        } else {
            errutil.errorMessageHandler(ex.message);
        }
        window.console && console.log && console.log(ex.message + '\n' + parsed.stack);
    },
    scripterr(ex, options) {
        errutil.box(null, ex, options);
    },
};

const waitingImpl = {
    waiting(show) {
        $('#waiting-dlg').toggle(show);
    },
};

function ajaxWaiting(settings, waiting) {
    if(waiting === true)
        waiting = waitingImpl.waiting;
    settings.beforeSend = function() {
        waiting(true);
    };

    function bindStopEvent(event) {
        if(typeof (settings[event]) == 'function') {
            settings[event] = [function() {
                waiting(false);
            }, settings[event]];
        } else {
            settings[event].unshift(function() {
                waiting(false);
            });
        }
    }
    bindStopEvent('success');
    bindStopEvent('error');
    return settings;
}


const api = {
    authenticator: null,
    __handle(url, params, options, cb) {
        if(typeof (options) == 'function') {
            cb = options;
            options = null;
        }

        if(!options)
            options = {};
        let deferred;
        if(!cb)
            deferred = $.Deferred();

        const response = function(err, data) {
            if(err) {
                const clazz = err?.parsedex?.clazz;
                if(!options.noauthenticator && api.authenticator?.protectedDocument && (clazz === 'err.auth')) {
                    Promise.resolve()
                        .then(() => api.authenticator.login(err))
                        .then(() => {
                            //retry api call, but now don't handle auth exception
                            const _options = {
                                ...options,
                                noauthenticator: true,
                                noalert: true,
                                errors: true,
                            };
                            return api.__handle(url, params, _options);
                        })
                        .then((_data) => response(null, _data))
                        .catch((_err) => response(_err));
                    return undefined;
                }
                if(!options.noalert)
                    errutil.scripterr(err);
                if(cb) {
                    if(!options.errors)
                        return undefined;
                    return cb(err);
                }
                return deferred.reject(err);
            }
            if(cb)
                return cb(null, data);
            return deferred.resolve(data);
        };

        let ajaxargs = {
            type: 'POST',
            url,
            data: params,
            headers: {},
            success(data) {
                //sometimes not json object
                if(typeof (data) === 'string') {
                    try { data = JSON.parse(data); } catch(err) { /**/ }
                }
                if(data && data.status && (data.status != 'ok')) {
                    const err = errutil.parse({ error: data.error || 'error', reason: data.message, stack: data.stack });
                    return response(err);
                }
                return response(null, data);
            },
            error(jqXHR, textStatus, errorThrown) {
                const err = errutil.parse(textStatus, errorThrown);
                return response(err);
            },
        };
        if(options.waiting)
            ajaxargs = ajaxWaiting(ajaxargs, options.waiting);
        $.ajax(ajaxargs);
        if(cb)
            return null;
        return deferred.promise();
    },
    handle(command, query, options, cb) {
        if(typeof (query) == 'function') {
            cb = query;
            query = null;
            options = null;
        }
        if(!query)
            query = '';
        return api.__handle(command, query, options, cb);
    },
};


function commonValidator(...options) {
    const defaults = {
        ignore: ':disabled,[readonly]',
        ignoreTitle: true,
        errorElement: 'div',
        errorClass: 'validation-label text-danger',
        validClass: 'validation-label text-success',
        errorPlacement(error, element) {
            let parent = element.parent();
            if(parent.is('.input-group'))
                parent = parent.parent();
            error.appendTo(parent);
        },
        highlight(element) {
            const el = $(element);
            const parent = el.parent();
            parent.addClass('has-error').removeClass('has-success');
        },
        unhighlight(element) {
            const el = $(element);
            const parent = el.parent();
            parent.addClass('has-success').removeClass('has-error');
        },
    };

    const _options = Object.assign({}, defaults, ...options);
    return _options;
}


const authenticator = {
    _initialized: false,
    _documentId: null,
    _userId: undefined,
    _authenticated: undefined,
    _completed: undefined,
    _otpHandle: undefined,
    protectedDocument: false,
    initialize(documentId, isSingleDocument) {
        if(authenticator._initialized) {
            return;
        }
        authenticator._initialized = true;
        authenticator._documentId = documentId;

        $('#login-form').validate(commonValidator({
            rules: {
                'login-password': { required: true },
            },
            submitHandler(form, event) {
                event.preventDefault();
                Promise.resolve()
                    .then(() => {
                        const params = {
                            document: authenticator._documentId,
                            otpHandle: authenticator._otpHandle,
                            otp: $('#login-password').val(),
                        };
                        const options = { errors: true, waiting: true, noauthenticator: true };
                        return api.handle(APP_ROOT + 'viewerui/authenticate.cmd', params, options);
                    })
                    .then(() => {
                        authenticator._authenticated?.();
                        authenticator._authenticated = undefined;
                        authenticator._otpHandle = undefined;
                    })
                    .catch(() => {
                        //error dialog already shown
                        $('#login-password')[0]?.focus();
                    });
            },
        }));
        $('#login-dialog').on('shown.bs.modal', () => {
            $('#login-send-credential')[0]?.focus();
            documentStateChange('auth-requested');
        });
        $('#login-dialog').on('hidden.bs.modal', () => {
            authenticator._completed?.();
            authenticator._completed = undefined;
            documentStateChange('auth-completed');
        });
        $('#login-send-credential').on('click', () => {
            Promise.resolve()
                .then(() => {
                    const params = { document: authenticator._documentId };
                    const options = { errors: true, waiting: true, noauthenticator: true };
                    return api.handle(APP_ROOT + 'viewerui/sendcredential.cmd', params, options);
                })
                .then(({ otpHandle }) => {
                    authenticator._otpHandle = otpHandle;
                    $('#login-form').find(':input[type=submit]').prop('disabled', false);
                    $('#login-error').text('').toggleClass('hidden', true);
                    $('#login-password')[0]?.focus();
                    errutil.errorMessageHandler(getUiText('loginWindow', 'sentmessage', t('auth.otp_delivery')), 'success', '', 2000);
                })
                .catch(() => {
                    //error dialog already shown
                });
        });
        authenticator.initializeUi();
    },
    initializeUi(isSingleDocument) {
        $('#login-header').html(getUiText('loginWindow', 'header', t('auth.authentication')));
        $('#login-username-label').text(getUiText('loginWindow', 'username', t('auth.username')));
        $('#login-send-credential').text(getUiText('loginWindow', 'sendbutton', t('auth.request_sms_code')));
        $('#login-password-label').text(getUiText('loginWindow', 'password', t('auth.otp_code')));
        $('#login-submit').text(getUiText('loginWindow', 'submit', isSingleDocument ? t('auth.open_document') : t('auth.open_sign_page')));
    },
    login(authError) {
        return Promise.resolve()
            .then(() => new Promise((resolve) => {
                const userId = authenticator._userId;
                authenticator._otpHandle = undefined;

                const validator = $('#login-form').validate();
                validator.resetForm();

                if(authError) {
                    window?.console?.log?.(authError.message + '\n' + (authError.parsedex?.stack || ''));
                    $('#login-error').text(authError.message);
                }

                $('#login-error').toggleClass('hidden', !authError);
                $('#login-form').find(':input[type=submit]').prop('disabled', true);
                $('#login-username').toggle(!!(userId?.SignerName || userId?.SignerFiscalCode));
                if(userId) {
                    $('#login-username').val(userId.SignerName || userId.SignerFiscalCode || '');
                }
                authenticator._authenticated = resolve;
                $('#login-dialog').modal('show');
            }))
            .then(() => new Promise((resolve) => {
                authenticator._completed = resolve;
                $('#login-dialog').modal('hide');
            }));
    },
    logout() {
        if(!authenticator.protectedDocument)
            return Promise.resolve();
        return Promise.resolve()
            .then(() => {
                const params = { document: authenticator._documentId };
                const options = { errors: true, waiting: true, noalert: true, noauthenticator: true };
                return api.handle(APP_ROOT + 'viewerui/logout.cmd', params, options);
            });
    },
    precheck() {
        return Promise.resolve()
            .then(() => {
                const params = { document: authenticator._documentId };
                const options = { errors: true, waiting: true, noalert: true, noauthenticator: true };
                return api.handle(APP_ROOT + 'viewerui/authorize.cmd', params, options);
            })
            .then(({ authorization, SignerName, SignerFiscalCode }) => {
                if(authorization == 'skip')
                    return Promise.resolve();
                authenticator.protectedDocument = true;
                api.authenticator = authenticator;
                const userId = { SignerName, SignerFiscalCode };
                authenticator._userId = userId;
                if(authorization == 'authorized')
                    return Promise.resolve(userId);
                return authenticator.login().then(() => userId);
            });
    },
    confirmLogout() {
        return new Promise((resolve) => {
            let confirmed = false;
            $('#logout-confirm-button')
                .off('click')
                .on('click', () => {
                    confirmed = true;
                    $('#logout-confirm-dialog').modal('hide');
                });
            $('#logout-confirm-dialog')
                .off('hidden.bs.modal')
                .on('hidden.bs.modal', () => { if(confirmed) resolve(); })
                .modal('show');
        });
    },
};


const LogEventType = {
    createList: 'createList',
    addDocument: 'addDocument',
    finalizeList: 'finalizeList',
    sendDocumentLink: 'sendDocumentLink',
    openList: 'openList',
    openDocument: 'openDocument',
    authenticationRequired: 'authenticationRequired',
    otpSend: 'otpSend',
    otpConfirm: 'otpConfirm',
    otpFailed: 'otpFailed',
    openSession: 'openSession',
    closeSession: 'closeSession',
    viewPage: 'viewPage',
    addSignature: 'addSignature',
    finalizeSignature: 'finalizeSignature',
    documentSignsFinished: 'documentSignsFinished',
    documentConfirmPressed: 'documentConfirmPressed',
    documentClosePressed: 'documentClosePressed',
    listSignsFinished: 'listSignsFinished',
    listConfirmPressed: 'listConfirmPressed',
    listClosePressed: 'listClosePressed',
    closeDocument: 'closeDocument',
    closeList: 'closeList',
};

const secureLog = {
    notifyServer(documentId, event, eventParams, { waiting, errors } = {}) {
        if(!LogEventType[event]) return Promise.resolve();
        const seconds = new Date().getTime();
        const params = { document: documentId, event, eventParams: JSON.stringify(eventParams), t: seconds };
        return api.handle('viewerui/securelog.cmd', params, { waiting, noalert: true, errors: true })
            .catch((err) => {
                if(errors) {
                    throw err;
                } else {
                    errutil.scripterr(err);
                }
            });
    },
};


function promisify(original, { errors } = {}) {
    return function(...args) {
        return new Promise((resolve, reject) => {
            args.push(function callback(...result) {
                if(errors && result[0]) {
                    reject(result[0]);
                    return;
                }
                resolve(errors ? result.slice(1) : result);
            });
            original.apply(this, args);
        });
    };
}

function callPromise(fn) {
    const promisified = promisify(fn);
    return promisified();
}


//can accept
//- UI datetime in format DD/MM/YYYY HH:mm
//- xml datetime in ISO8601 format
//- JavaScript Date
//- moment
//- any other formats moment constructor accept
//in case of UI and xml datetime automatically determines if time part is set, and can convert to corresponding UI/xml format
//dates are treated very special, they are always in UTC with time set to 00:00:00, Z is never added to the end, so they convert to the same dates always
function timeformat(time, options) {
    if(!options)
        options = {};
    if(options.forceUtc === undefined)
        options.forceUtc = false;

    const params = {
        forceUtc: options.forceUtc,
        haveTime: true,
    };

    function parseSpecialFormats(time0) {
        if(!time0 || (typeof (time0) != 'string'))
            return time0;
        let obj = timeformat._splitDisplayTime(time0);
        if(!obj) {
            obj = timeformat._splitXmlTime(time0);
            //will be parsed automatically by moment.js
            if(!obj || (obj.haveTime && !params.forceUtc))
                return moment.parseZone(time0);
        }
        params.haveTime = obj.haveTime;
        params.forceUtc = params.forceUtc || !obj.haveTime;
        const array = [obj.year, obj.month - 1, obj.day];
        if(obj.haveTime)
            array.push(obj.hour, obj.minute, obj.second, obj.millisecond);
        if(params.forceUtc)
            time0 = moment.utc(array);
        else
            time0 = moment(array);
        return time0;
    }

    time = parseSpecialFormats(time);
    if(time) {
        if(time === 'now')
            time = moment();
        else if(!moment.isMoment(time))
            time = moment(time);
    }

    this.toMoment = function() {
        return time && time.clone();
    };
    this.toDate = function() {
        return time && time.clone().toDate();
    };
    this.toMillis = function() {
        return time && time.toDate().getTime();
    };

    function formatTime(_format, options0) {
        if(!time)
            return time;
        if(!options0)
            options0 = {};
        if(options0.needTime === undefined)
            options0.needTime = params.haveTime;
        if(options0.zone === undefined)
            options0.zone = params.haveTime;

        let format = _format.date;
        if(options0.needTime) {
            format += _format.sep || '';
            format += _format.time;
            format += _format.millis || '';
        }
        if(options0.zone)
            format += _format.Z || '';
        if(params.forceUtc || _format.utc)
            time.utc();
        else
            time.local();
        return time.format(format);
    }
    this.toXml = function(options0) {
        return formatTime({
            utc: true,
            date: 'YYYY-MM-DD',
            sep: '[T]',
            time: 'HH:mm:ss',
            millis: '.SSS',
            Z: '[Z]',
        }, options0);
    };
    this.toDisplayTime = function(options0) {
        return formatTime({
            utc: false,
            date: 'DD/MM/YYYY',
            sep: ' ',
            time: 'HH:mm',
        }, options0);
    };
    this.toLocalizedTime = function(options0) {
        return formatTime({
            utc: false,
            date: 'DD/MM/YYYY',
            sep: ' ',
            time: 'HH:mm:ss',
        }, options0);
    };
}
timeformat._displayTimeRegex = /^(\d{2})\/(\d{2})\/(\d{4})( (\d{2}):(\d{2}))?$/;
timeformat._splitDisplayTime = function(time) {
    const result = timeformat._displayTimeRegex.exec(time);
    if(!result)
        return null;
    const haveTime = result[4];
    const obj = {
        year: result[3], month: result[2], day: result[1], hour: '00', minute: '00', second: '00', millisecond: '000', haveTime,
    };
    if(haveTime) {
        obj.hour = result[5];
        obj.minute = result[6];
    }
    return obj;
};
// eslint-disable-next-line no-useless-escape
timeformat._xmlTimeRegex = /^(\d{4})\-(\d{2})\-(\d{2})(T(\d{2}):(\d{2}):(\d{2})(\.\d{3})?)?(Z|[+-]\d{1,2}(:\d{1,2})?)?$/;
timeformat._splitXmlTime = function(time) {
    const result = timeformat._xmlTimeRegex.exec(time);
    if(!result)
        return null;
    const haveTime = result[4];
    const obj = {
        year: result[1], month: result[2], day: result[3], hour: '00', minute: '00', second: '00', millisecond: '000', haveTime,
    };
    obj.fullDate = obj.year + '-' + obj.month + '-' + obj.day;
    if(haveTime) {
        obj.hour = result[5];
        obj.minute = result[6];
        obj.second = result[7];
        if(result[8])
            obj.millisecond = result[8];
    }
    if(result[9])
        obj.zone = result[9];
    return obj;
};
//throws away all crap like 00:00:00+02:00 and returns only date part without zone info
timeformat.fixDateXml = function(value) {
    if(!value)
        return value;
    if(typeof (value) != 'string')
        value = new timeformat(value).toXml({ date: true, Z: false });
    const obj = timeformat._splitXmlTime(value);
    if(!obj)
        return value;
    return obj.fullDate;
};
//converted as is, no zone info stored/converted
timeformat.rawDisplayTimeToXml = function(value) {
    if(!value)
        return value;
    const obj = timeformat._splitDisplayTime(value);
    if(!obj)
        return value;
    return obj.year + '-' + obj.month + '-' + obj.day + (obj.haveTime ? ('T' + obj.hour + ':' + obj.minute + ':' + obj.second) : '');
};
timeformat.rawXmlToDisplayTime = function(value) {
    if(!value)
        return value;
    const obj = timeformat._splitXmlTime(value);
    if(!obj)
        return value;
    return obj.day + '/' + obj.month + '/' + obj.year + (obj.haveTime ? (' ' + obj.hour + ':' + obj.minute) : '');
};


function SubstitutionProcessor(variables, locale) {
    this.variables = variables;
    this.locale = locale;
}
SubstitutionProcessor.prototype = {
    variables: null,
    locale: null,
    process(value) {
        // eslint-disable-next-line no-useless-escape
        const regex = /\$\{([^:\}]+)(::)?([^\}]+)?\}/g;
        let last = 0;
        regex.lastIndex = last;
        let match;
        let result = '';

        while((match = regex.exec(value)) !== null) {
            const first = last;
            last = regex.lastIndex;
            const to = last - match[0].length;
            result += value.substring(first, to);
            const name = match[1];
            const format = match[3];
            if(!(name in this.variables))
                continue;
            result += this.formatVariable(this.variables[name], format);
        }
        result += value.substring(last, value.length);
        return result;
    },
    formatVariable(variable, format) {
        let value = variable.value;
        if(!format)
            format = variable.format;
        if(!format)
            return value;
        const type = variable.type;
        switch(type) {
            case 'Date':
            case 'Time':
            case 'DateTime':
                {
                    if(/^\d{2}:\d{2}:\d{2}/.test(value))
                        value = moment().format('YYYY-MM-DD[T]') + value;
                    //see http://momentjs.com/docs/#/displaying/format/
                    const m = new timeformat(value).toMoment();
                    m.locale(this.locale);
                    if(type == 'DateTime')
                        m.local();
                    value = m.format(format);
                }
                break;
            case 'Number':
                //see http://numeraljs.com/
                value = numeral(Number(value)).format(format);
                break;
        }
        return value;
    },
};

const XML_CHARACTER_MAP = {
    '&': '&amp;',
    '"': '&quot;',
    "'": '&apos;',
    '<': '&lt;',
    '>': '&gt;',
};
function xmlescape(string) {
    return string && string.replace
        ? string.replace(/([&"<>'])/g, function(str, item) {
            return XML_CHARACTER_MAP[item];
        }) : string;
}

function toFloat(n) {
    return (typeof (n) === 'number') ? n : parseFloat(n);
}

// for testing
function documentStateChange(state) {
    $('#pagestatevalue').val(state);
}

const tools = {
    promisify,
    callPromise,
    api: api.handle,
    authenticator,
    LogEventType,
    secureLog,
    waiting: waitingImpl,
    scripterr: errutil.scripterr,
    errutil,
    timeformat,
    SubstitutionProcessor,
    xmlescape,
    ok(message) {
        PNotify.success({ title: message || t('common.ok'), delay: 20000 });
    },
    confirm(message, cb) {
        return new Promise((resolve) => {
            function callback(result, notice) {
                notice.close();
                if(cb)
                    cb(result);
                else
                    resolve(result);
            }
            PNotify.alert({
                title: message || t('common.are_you_sure'),
                hide: false,
                modules: {
                    Buttons: {
                        closer: false,
                        sticker: false,
                    },
                    Mobile: {
                        swipeDismiss: false,
                    },
                    Confirm: {
                        confirm: true,
                        buttons: [{
                            text: t('common.ok'),
                            primary: true,
                            promptTrigger: true,
                            click: callback.bind(null, true),
                        }, {
                            text: t('common.cancel'),
                            click: callback.bind(null, false),
                        }],
                    },
                },
                stack: {
                    modal: true,
                    overlayClose: false,
                },
            });
        });
    },
    toFloat,
    documentStateChange,
};

export default tools;
